(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function animateHero(root) {
    if (reducedMotion.matches || !window.gsap || !document.body.classList.contains('template-index')) return;

    const animator = window.gsap;
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.buy-any-two-landing__button.button').forEach((button) => {
      if (button.dataset.fathersDayGsapReady === 'true') return;
      button.dataset.fathersDayGsapReady = 'true';

      const sheen = document.createElement('span');
      sheen.className = 'buy-any-two-landing__button-sheen';
      sheen.setAttribute('aria-hidden', 'true');
      button.appendChild(sheen);

      animator.to(button, {
        scale: 1.012,
        y: -1,
        boxShadow: '0 1.55rem 3.6rem rgba(0, 0, 0, 0.24), 0 0 0 0.45rem rgba(0, 0, 0, 0.055)',
        duration: 0.9,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });

      animator.fromTo(
        sheen,
        { xPercent: -170, skewX: -18 },
        {
          xPercent: 330,
          duration: 1.1,
          repeat: -1,
          repeatDelay: 2.2,
          ease: 'power2.inOut'
        }
      );

      button.addEventListener('pointerdown', () => {
        animator.to(button, { scale: 0.985, y: 1, duration: 0.12, overwrite: 'auto', ease: 'power2.out' });
      });

      ['pointerup', 'pointerleave', 'blur'].forEach((eventName) => {
        button.addEventListener(eventName, () => {
          animator.to(button, { scale: 1, y: 0, duration: 0.28, overwrite: 'auto', ease: 'back.out(2)' });
        });
      });
    });

    scope.querySelectorAll('.buy-any-two-landing__content .section-heading__subtitle').forEach((badge) => {
      if (badge.dataset.fathersDayGsapReady === 'true') return;
      badge.dataset.fathersDayGsapReady = 'true';

      animator.fromTo(
        badge,
        { scale: 0.96, y: 4, opacity: 0 },
        { scale: 1, y: 0, opacity: 1, duration: 0.55, ease: 'back.out(1.8)', delay: 0.1 }
      );

      animator.to(badge, {
        y: -1,
        duration: 1.45,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 0.8
      });
    });

    scope.querySelectorAll('.buy-any-two-how__step').forEach((step, index) => {
      if (step.dataset.fathersDayGsapReady === 'true') return;
      step.dataset.fathersDayGsapReady = 'true';

      animator.fromTo(
        step,
        { y: 12, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.52, ease: 'power2.out', delay: 0.18 + index * 0.08 }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => animateHero(document));
  } else {
    animateHero(document);
  }

  document.addEventListener('shopify:section:load', (event) => animateHero(event.target));
})();
